<template>
    <div class="dnb-container">
        <update-loader :style="{order :componentOrder.updating}" v-if="updating"></update-loader>
        <div :style="{order :componentOrder.updating}" class="placeholder" v-else></div>
        <div :style="{order :componentOrder.header}">
            <logo v-if="!makeFullScreen && noticeBoard.pictures && noticeBoard.pictures.length && (!$kmsTheme || $kmsTheme.logoSupported)"
                  :pictures="noticeBoard.pictures" 
                  :class="logoClass"></logo>
            <clock :class="clockClass" v-if="!makeFullScreen && noticeBoard.displayLiveClock && (!$kmsTheme || $kmsTheme.clockSupported)"></clock>
        </div>

        <notice-messages @message-changed="messageChanged" :style="{order :componentOrder.messages}" class="notice-message-wrapper" v-if="noticeBoard.digitalNoticeBoardId && messages.length" :messages="messages" :noticeBoard="noticeBoard"></notice-messages>
        <footer-text :style="{order :componentOrder.footer}" v-if="!makeFullScreen && noticeBoard.footer  && (!$kmsTheme || $kmsTheme.footerSupported)" :footer="noticeBoard.footer"></footer-text>
        <ticker-tape :style="{order :componentOrder.tickerTape}" v-show="!makeFullScreen" v-if="noticeBoard.displayBBCTickerTape && (!$kmsTheme || $kmsTheme.tickerTapeSupported)"></ticker-tape>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Logo from './logo';
    import Clock from './clock';
    import NoticeMessages from './notice-messages';
    import TickerTape from './ticker-tape';
    import UpdateLoader from './update-loader';
    import Footer from './footer';
import { should } from 'chai';
import { BIconShopWindow } from 'bootstrap-vue';
//import { component } from 'vue/types/umd';

    Vue.component('update-loader', UpdateLoader);
    Vue.component('clock', Clock);
    Vue.component('logo', Logo);
    Vue.component('notice-messages', NoticeMessages);
    Vue.component('ticker-tape', TickerTape);
    Vue.component('footer-text', Footer);

    export default {
        data() {
            return {
                componentOrder: {
                    updating: 1,
                    header: 2,
                    messages: 3,
                    footer: 4,
                    tickerTape:5
                },
                logoClass: {},
                clockClass: {},
                updating: {
                    type: Boolean
                },
                makeFullScreen: false
            }
        },
        props: {
            
            noticeBoard: {},
            messages: {},
            
        },
        methods: {
            messageChanged(noticeMessage) {
                if (!noticeMessage.sticky && noticeMessage.fullScreen)
                    this.makeFullScreen = true;
                else
                    this.makeFullScreen = false;
            },
            showUpdating: function () {
                this.updating = true;
                if (this.interval) {
                    window.clearTimeout(this.interval);
                }
                this.interval = window.setTimeout(() => {
                    console.log("show updating timeout ");
                    this.updating = false;
                }, 3000);

            },
            setupLayout: function () {
                this.logoClass = "left-logo";
                this.clockClass = "right-clock";

                if (!this.$kmsTheme)
                    return;

                var layout = this.$kmsTheme.layout;

                if (!layout)
                    return;

                if (layout.updatingOrder) {
                    var newOrder = {
                        updating: layout.updatingOrder || this.componentOrder.updating,
                        header: layout.headerOrder || this.componentOrder.headerOrder,
                        messages: layout.messageOrder || this.componentOrder.messageOrder,
                        tickerTape: layout.tickerOrder || this.componentOrder.tickerTape,
                        footer: layout.footerOrder || this.componentOrder.footerOrder
                    }
                    this.componentOrder = newOrder;
                }

                if (layout.clockAlign)
                    this.clockClass = layout.clockAlign + "-clock";

                if (layout.logoAlign)
                    this.logoClass = layout.logoAlign + "-clock";
                
            }
        },
        created() {
            console.log('home page content created');
            this.updating = false;
            this.setupLayout();
            console.log('home page content created - finished');
        },
        mounted() {
            this.$noticeBoardHub.on('NotifyUpdating', this.showUpdating);
        },
        watch: {
            messages() {
                if (this.messages.length == 1) {
                    this.messageChanged(this.messages[0]);
                }
            }
        }
    }

</script>

<style scoped>
    .dnb-container {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .notice-message-wrapper {
        flex-grow: 1;
        clear: both;
        min-height: 0;
        min-width: 0;
        display: flex;
        position: relative;
    }
    /*.notice-message-wrapper {
        position: absolute;
        top: 130px;
        left: 0;
        right: 0;
        bottom: 80px;
    }*/
</style>

<style>
    .left-logo {
        float: left;
        clear: left;
    }

    .placeholder {
        height: 20px;


        position: absolute;
        top: 0px;
        right: 0;
        left: 0;
    }

    .right-clock {
        float: right;
        clear: right;
    }
</style>
